import PropTypes from 'prop-types';
import LookBookDropDown from './LookBookDropDown';
import LookBookCollageList from './LookBookCollageList';
import LookBookCollageContainer from './LookBookCollageContainer';

export default class LookBookPanel extends React.Component {
    static propTypes = {
        inspirationsData: PropTypes.array,
        inspirationIdParameter: PropTypes.number
    };
    static defaultProps = {
        inspirationsData: [],
        inspirationIdParameter: null
    };
    constructor() {
        super();

        this.state = {
            isDDLOpen: false,
            selectedInspiration: {},
            ceremonyLook: true,
            isDisplayingVideo: false,
            isSelectionCombination: false
        };
    }
    componentWillMount() {
        if (this.props.inspirationIdParameter) {
            const selectedInspiration = {};

            selectedInspiration.id = this.props.inspirationIdParameter;
            selectedInspiration.name = this._queryInspirationName(this.props.inspirationIdParameter);

            this.setState({ selectedInspiration });
        }
        if (window.location.search.length) {
            const params = this._retrieveURLParameters();

            if (params && params.isCeremony === 'false') {
                this.setState({ ceremonyLook: !this.state.ceremonyLook });
            }
        }
    }
    componentDidMount() {
        $('.sandals-loader').hide();
    }
    _onSelectCombinationHandler = (e) => {
        const selectedInspiration = {};

        selectedInspiration.id = e.currentTarget.id;
        selectedInspiration.name = `Inspired by ${e.currentTarget.id}`;
        this.setState({
            isSelectionCombination: true,
            isDisplayingVideo: false,
            isDDLOpen: false,
            selectedInspiration
        });
    };
    _lookBookCntrlHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentDdlState = this.state.isDDLOpen;
        let newDdlState;

        (currentDdlState) ? newDdlState = null : newDdlState = true;

        this.setState({ isDDLOpen: newDdlState });
    };
    _onSelectLookBookItem = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const selectedInspiration = {};

        selectedInspiration.id = parseInt(e.currentTarget.id, 10);
        selectedInspiration.name = this._queryInspirationName(parseInt(e.currentTarget.id, 10));

        this.setState({
            selectedInspiration,
            isDDLOpen: false,
            isDisplayingVideo: false,
            isSelectionCombination: false
        });
    };
    _onClickInspirationLookHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const ceremonyLook = (e.currentTarget.id === 'ceremony') ? true : false;

        $('.close-video').addClass('hide');

        this.setState({ ceremonyLook, isDisplayingVideo: false });
    };
    _onClickVideoPlaceholderHandler = () => {
        this.setState({ isDisplayingVideo: !this.state.isDisplayingVideo });
    };
    _queryInspirationName = (inspirationId) => {

        const selectedInspirationIndex = this.props.inspirationsData.findIndex( (el) => el.id === inspirationId );
        const selectedInspirationName = this.props.inspirationsData[selectedInspirationIndex].name;

        return selectedInspirationName;
    };
    _queryInspirationImgArray = (inspirationId, type) => {

        const selectedInspirationIndex = this.props.inspirationsData.findIndex( (el) => el.id === inspirationId );
        const selectedInspirationImgArray = (selectedInspirationIndex >= 0) ? this.props.inspirationsData[selectedInspirationIndex].images[`${type}`] : [];

        return selectedInspirationImgArray;
    };
    _queryInspirationVideoPlaceholder = (inspirationId) => {

        const selectedInspirationIndex = this.props.inspirationsData.findIndex( (el) => el.id === inspirationId );
        const selectedInspirationVideoPlaceholder = (selectedInspirationIndex >= 0) ? this.props.inspirationsData[selectedInspirationIndex].images.video : [];

        return selectedInspirationVideoPlaceholder;
    };
    _retrieveURLParameters = () => {
        const paramSplitter = (acc, currentEl) => {
            const splittedParams = currentEl.split('=');
            const key = splittedParams[0];
            const value = splittedParams[1];

            acc[key] = value;

            return acc;
        };
        const urlParameters = window.location.search.slice(1).split('&').reduce(paramSplitter, {});

        return urlParameters;
    };
    render() {

        const { id: selectedInspirationId } = this.state.selectedInspiration;

        return (
            <section className="look-book-section">
                <div className="look-book-ddl-wrapper bg-white pr">
                    <div className="container">
                        <a href="/en/weddings/ideas/" className="back-btn">
                            <i className="ic ic-button-arrow-prev"/>
                            BACK TO INSPIRATIONS
                        </a>
                        {
                            this.state.selectedInspiration.id && <h4 className="gold-label">SELECT A WEDDING LOOK BOOK</h4>
                        }
                        <LookBookDropDown
                            lookBookCntrlHandler = {  this._lookBookCntrlHandler }
                            onSelectLookBookItem = { this._onSelectLookBookItem }
                            isDDLOpen = { this.state.isDDLOpen }
                            selectedInspiration = { this.state.selectedInspiration }
                            inspirationsData = { this.props.inspirationsData }
                            onSelectCombination = { this._onSelectCombinationHandler }
                            isSelectionCombination = { this.state.isSelectionCombination }
                            willRenderDropDown = { (selectedInspirationId) ? true : false }
                        />
                    </div>
                    {
                        this.state.selectedInspiration.id ?
                        <LookBookCollageContainer
                            ceremonyLook = { this.state.ceremonyLook }
                            selectedInspiration = { this.state.selectedInspiration }
                            onClickInspirationLookHandler = { this._onClickInspirationLookHandler }
                            ceremonyLookImg = { this._queryInspirationImgArray(selectedInspirationId, 'ceremony') }
                            receptionLookImg = { this._queryInspirationImgArray(selectedInspirationId, 'reception') }
                            videos = { this._queryInspirationVideoPlaceholder(selectedInspirationId) }
                            isDisplayingVideo = { this.state.isDisplayingVideo }
                            onClickVideoPlaceholderHandler = { this._onClickVideoPlaceholderHandler }
                            isSelectionCombination = { this.state.isSelectionCombination }
                        /> :
                        <LookBookCollageList inspirationsData = { this.props.inspirationsData } />
                    }
                </div>
            </section>
        );
    }
}
